import { Blog } from "../../../schema/models";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Schema } from "effect";
import { NotFound } from "@effect/platform/HttpApiError";
export default HttpApiGroup.make("blogv1").annotate(OpenApi.Title, "Blog V1").add(HttpApiEndpoint.get("getPostBySlug")`/posts/:postSlug`.setPath(Schema.Struct({
    postSlug: Schema.String
})).addSuccess(Blog.Model).addError(NotFound).annotate(OpenApi.Summary, "Get Post By Slug")).prefix("/v1/blog");
